module.exports = __webpack_public_path__ + "static/icon-384x384-8fbf30d97ddc784c01c30ae8b0e7ae23.png";